import { fetchWithAuth } from '../utils/auth';

export interface UserProfile {
  UserID: string;
  UserName?: string | null;
  Name?: string | null;
  Bio?: string | null;
  ProfileImageURL?: string | null;
  ProfileImageThumbnailURL?: string | null;
  BannerURL?: string | null;
  AccountStatus?: string;
  AccountType?: string;
  IsPlusVerified?: boolean;
  IsVerified?: boolean;
  IsEmailVerified?: boolean;
  IsPhoneVerified?: boolean;
  HasPassword?: boolean;
  HasEmail?: boolean;
  FollowersTotal?: number;
  FollowingTotal?: number;
  TotalVideos?: number;
  Country?: string;
  Location?: string;
  createdAt?: string;
  PendingProductChange?: string | null;
  CurrentProductId?: string | null;
  IsPaidForVerification?: boolean;
  [key: string]: unknown;
}

export const getUserProfile = async (userId: string): Promise<UserProfile | null> => {
  const response = await fetchWithAuth(`https://api.tezda.tech/user/t/getUserProfile`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ UserID: userId }),
  });

  const json = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(json?.message || 'Failed to load user profile');
  }

  return (json?.data ?? null) as UserProfile | null;
};
